@if (loading$ | async) {
  <mat-progress-spinner
    mode="indeterminate"
    [diameter]="150"
  ></mat-progress-spinner>
}
@if (!(loading$ | async)) {
  <lib-button
    >Wybierz max 5 zdjęć <input type="file" multiple (change)="picked($event)" />
  </lib-button>
}
